import React from 'react'
import { useCustomWorkflowsEnabled } from '../../../common/useCustomWorkflowsEnabled'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { EntityWorkflowResults } from './EntityWorkflowResults'

export interface DocumentWorkflowResultsProps {
  documentId: string
}

export const DocumentWorkflowResults: React.FC<DocumentWorkflowResultsProps> = ({ documentId }) => {
  const accountId = useAppSelector(selectAccountId)
  const { enabled } = useCustomWorkflowsEnabled()

  if (!enabled) return null

  return (
    <div className='p-4 zocks-border-0.5 border zocks-border-color-gray-300 d-flex flex-column gap-4'>
      <div className='d-flex align-items-center justify-content-between'>
        <span className='paragraph-large bold'>Workflows</span>
      </div>
      <EntityWorkflowResults entityType='document' entityId={documentId} accountId={accountId} />
    </div>
  )
}
